var _a;
import { createApp } from 'vue';
import Logos from './components/Logos.vue';
var el = document.getElementById('logos');
if (el) {
    var localizationCode = (_a = el.dataset.localizationCode) !== null && _a !== void 0 ? _a : '';
    createApp(Logos, { localizationCode: localizationCode }).mount(el);
}
